import { Box, Button, Group, Paper, Text } from "@mantine/core";
import { useEffect, useState } from "react";
import { initFCMActive } from "@/fcm";
import { useLocalStorage } from "@/utils/localstorage";

export const NotificationPrompt = () => {
  const [notificationsDeclined, setNotificationsDeclined] = useLocalStorage(
    "notifications_declined",
    false,
  );
  const [showPrompt, setShowPrompt] = useState(false);

  useEffect(() => {
    if (typeof window !== "undefined" && "Notification" in window) {
      setShowPrompt(
        !notificationsDeclined && Notification.permission === "default",
      );
    }
  }, [notificationsDeclined]);

  const handleYes = async () => {
    setShowPrompt(false);
    await initFCMActive();
    // After user interaction, the browser will remember their choice
  };

  const handleNo = () => {
    setNotificationsDeclined(true);
    setShowPrompt(false);
  };

  if (!showPrompt) return null;

  return (
    <Paper p="md" bdrs="md" bg="gray.0">
      <Group>
        <Box style={{ flex: 1 }}>
          <Text size="md">Would you like to receive push notifications?</Text>
          <Text size="sm">You can change this later.</Text>
        </Box>
        <Button color="green" variant="light" onClick={handleYes}>
          Yes
        </Button>
        <Button color="red" variant="light" onClick={handleNo}>
          No
        </Button>
      </Group>
    </Paper>
  );
};
